import { OpenFlyingStatusType } from "@vmosolutions/oc-interfaces";
import { useTheme, Theme } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import Tooltip from "@mui/material/Tooltip";

interface IOpenFlyingIconsProps {
  flyingStatusType?: OpenFlyingStatusType;
}

const openFlyingStyles = (theme: Theme): any => ({
  width: 14,
  height: 14,
});

/**
 * Return appropriate icon type for assigned openflying type on position.
 * @param props - Array of PairingEventGroups
 */
export const OpenFlyingIcons = (props: IOpenFlyingIconsProps): JSX.Element => {
  const { flyingStatusType } = props;
  const theme: Theme = useTheme();
  return flyingStatusType === OpenFlyingStatusType.OpenVisible ? (
    <Tooltip enterDelay={500} placement="top" title="Open Flying: Open - Visible To Crew">
      <LockOpenTwoToneIcon sx={openFlyingStyles(theme)} />
    </Tooltip>
  ) : flyingStatusType === OpenFlyingStatusType.OpenNonVisible ? (
    <Tooltip enterDelay={500} placement="top" title="Open Flying: Open - Hidden To Crew">
      <LockOpenIcon sx={openFlyingStyles(theme)} />
    </Tooltip>
  ) : (
    <Tooltip enterDelay={500} placement="top" title="Open Flying: Closed">
      <LockIcon sx={openFlyingStyles(theme)} />
    </Tooltip>
  );
};
